(function() {
    'use strict';

a3_cabin_reports.directive('eventHistory',eventHistory);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name eventHistory
   * @restrict E
   * @description
   *   Implementation of eventHistory
   *   Initialize the Event History of report incidents (mockup view).
   * @example
   *   Usage:
   *   <event-history></event-history>
   * @ngInject
   */    
function eventHistory() {

		return {
			restrict: 'E',
            templateUrl: 'views/directives/eventHistory.tpl.html',
		}
	}

})();
	